export class ListShipmentDeliveryPlaceFilter {
    currentHubId?: number;
    compartmentId?: number;
    shipmentNumber?: string;
    shipmentNumberS?: string;
    shipmentNumberW?: string;
    toHubId?: number;
    receiverName?: string;
    receiverPhone?: string;
    toDistrictId?: number;
    toWardId?: number;
    streetName?: string;
    fromDate?: any;
    toDate?: any;
    typeShipmentBoxs?: number;
    deliveryVehicleTypeId?: number;
    pageNumber?: number;
    pageSize?: number;
    shipmentNumberContract?: any;
    shippingAddress:string;
    shipmentNumberSs:any[]=[];
    orderTypeId:any;
    priorityTypeId:any;
}